import { useState, useEffect } from 'react';
import { Companion } from '../types';
import { supabase } from '../lib/supabaseClient';
import { getPublicStorageUrl } from '../utils/storage';
import { toCamelCase } from '../utils/caseConversion';

export const useCompanions = () => {
  const [companions, setCompanions] = useState<Companion[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompanions = async () => {
      try {
        setLoading(true);
        setError(null);

        console.log('🔄 Chargement des compagnons depuis Supabase...');

        const { data: companionsData, error: companionsError } = await supabase
          .from('elements')
          .select('*')
          .eq('type', 'companion')
          .order('created_at', { ascending: false });

        if (companionsError) {
          throw new Error(`Erreur Supabase: ${companionsError.message}`);
        }

        // Convert snake_case from database to camelCase for JavaScript
        const companionsDataCamelCase = toCamelCase(companionsData);

        // Transform Supabase format to Companion interface
        const transformedCompanions: Companion[] = (companionsDataCamelCase || []).map((companion: any) => ({
          id: companion.id,
          name: companion.translations?.fr?.name || 'Compagnon',
          description: companion.translations?.fr?.description,
          emoji: getPublicStorageUrl(companion.assetUrl),
          unlocked: companion.unlocked,
          bookId: companion.rewardFrom?.bookId,
          hasBeenPublished: companion.hasBeenPublished || false
        }));

        console.log(`✅ ${transformedCompanions.length} compagnons chargés depuis Supabase`);
        setCompanions(transformedCompanions);

      } catch (err) {
        console.error('❌ Erreur lors du chargement des compagnons:', err);
        setError(err instanceof Error ? err.message : 'Erreur inconnue');
        setCompanions([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCompanions();
  }, []);

  return {
    companions,
    loading,
    error,
    refetch: () => {
      setLoading(true);
      setError(null);
      window.location.reload();
    }
  };
};

export default useCompanions;
